import ToggleButton from "@mui/material/ToggleButton";
import isFunction from "lodash/isFunction";
import isObject from "lodash/isObject";
import React from "react";
import SelectToggleButtonGroup from "./shared/SelectToggleButtonGroup";

const SelectToggleInput = ({
  value,
  onChange,
  size,
  fullWidth,
  sx,
  disabled,
  options,
  helperText,
  seperator,
  error,
  exclusive,
}) => {
  const handleOnChange = (event, val) => {
    if (disabled) {
      return;
    }
    if (!isFunction(onChange)) {
      console.error("onChange is not a function");
      return;
    }
    onChange(val);
  };

  return (
    <SelectToggleButtonGroup
      value={value}
      exclusive={exclusive}
      sx={sx}
      size={size}
      disabled={disabled}
      fullWidth={fullWidth}
      onChange={handleOnChange}
      helperText={helperText}
      error={error}
    >
      {options?.map((option, index) => {
        const option_label = isObject(option) ? option?.label : option;
        const option_value = isObject(option) ? option?.value : option;
        // console.log("option_value", { option_value, option_label });
        return (
          <React.Fragment key={`toggle-${option_value}-${index}`}>
            <ToggleButton
              value={option_value}
              disabled={disabled}
              // key={`toggle-button-${option_value}-${index}`}
              aria-label={option_label}
            >
              {option_label}
            </ToggleButton>
            {seperator && index + 1 !== options?.length ? seperator : null}
          </React.Fragment>
        );
      })}
    </SelectToggleButtonGroup>
  );
};

export default SelectToggleInput;
